(function () {
  if (!window.USF_CFG) return;

  // -------- Locale & rate ----------
  var locale  = String(window.USF_CFG.locale || '').toLowerCase();
  var eurRate = Number(window.USF_CFG.eurRate || 0.1333); // fallback ≈ 1/7.50
  var isEN    = /^en(\-|$)/.test(locale);

  function toEUR(dkk){ return Number(dkk) * eurRate; }
  // Cent-afrunding + EU tusindtals-separator
  function fmtEUR(amount){
    var rounded   = Math.round(Number(amount));       // hele euro
    var formatted = rounded.toLocaleString('de-DE');  // fx 1.234.567
    return '€ ' + formatted;
  }

  // Robust DKK-parser: "8.800 DKK" / "8,800.00" / "8.800,00" / "8800"
  function parseDKK(txt){
    if (!txt) return null;
    var s = String(txt)
      .replace(/\u00a0/g,'')      // NBSP
      .replace(/\s/g,'')          // mellemrum
      .replace(/DKK|kr\.?/ig,''); // valuta labels

    var hasDot   = s.indexOf('.') > -1;
    var hasComma = s.indexOf(',') > -1;

    if (hasDot && hasComma){
      var last = Math.max(s.lastIndexOf('.'), s.lastIndexOf(','));
      var dec  = s.charAt(last);
      var th   = dec === '.' ? ',' : '.';
      s = s.split(th).join('');
      s = s.replace(dec, '.');
      var v0 = parseFloat(s);
      return isNaN(v0) ? null : v0;
    }

    if (hasDot){
      if (/^\d{1,3}(\.\d{3})+$/.test(s)) s = s.split('.').join('');
      var v1 = parseFloat(s);
      return isNaN(v1) ? null : v1;
    }

    if (hasComma){
      if (/^\d{1,3}(,\d{3})+$/.test(s)) {
        s = s.split(',').join('');
      } else {
        s = s.replace(',', '.');
      }
      var v2 = parseFloat(s);
      return isNaN(v2) ? null : v2;
    }

    var v3 = parseFloat(s);
    return isNaN(v3) ? null : v3;
  }

  // ---------- FEATURED/SLIDER-KORT (tema-render) ----------
  (function patchFeatured(){
    if (!isEN) return;

    function convertNode(el){
      var txt = (el.textContent || '').trim();
      if (!txt || /€/.test(txt)) return;
      if (!/DKK|kr/i.test(txt)) return;

      var prefix = ((txt.match(/^(Fra|From)\s+/i)||[])[0] || '');
      var val = parseDKK(txt); if (val==null) return;

      el.textContent = prefix + fmtEUR(toEUR(val));
      el.classList && el.classList.remove('money');
    }

    function rewrite(root){
      (root || document).querySelectorAll(
        '.featured-collection-slider .product-card .price, .featured-collection-slider .product-card .price-before'
      ).forEach(convertNode);
    }

    rewrite(document);
    var target = document.querySelector('.featured-collection-slider') || document.body;
    var mo = new MutationObserver(function(){ rewrite(target); });
    mo.observe(target, {childList:true, subtree:true, characterData:true});
  })();

  // ---------- TEMAETS DRAWER / MINICART (sikker, attribut-baseret) ----------
  (function patchDrawerSafe(){
    if (!isEN) return;

    function setText(node, val){
      if (!node) return;
      node.textContent = val;
    }

    function readCents(el, names){
      for (var i=0;i<names.length;i++){
        var v = el.getAttribute(names[i]);
        if (v != null && v !== '') {
          var n = Number(v);
          if (!isNaN(n)) return n;
        }
      }
      return null;
    }

    function rewriteDrawer(){
      var drawer = document.querySelector('.drawer');
      if (!drawer) return;

      var subtotalCents = 0;

      // 1) Enhedspris pr. vare
      drawer.querySelectorAll('.items .item').forEach(function(item){
        var unitCents = readCents(item, ['final_price','original_price','presentment_price']);
        var lineCents = readCents(item, ['final_line_price','line_price','original_line_price']);

        if (unitCents != null){
          var unitEUR = fmtEUR(toEUR(unitCents / 100));
          var unitNode = item.querySelector('.item-price span, .item-price, [class*="price"]');
          setText(unitNode, unitEUR);
        }

        if (lineCents != null){
          subtotalCents += lineCents;
        }
      });

      // 2) Subtotal (total_price-blokken)
      if (subtotalCents > 0){
        var subtotalDKK = subtotalCents / 100;
        var subtotalNode = drawer.querySelector('.total_price p:last-child, .total_price div p');
        setText(subtotalNode, fmtEUR(toEUR(subtotalDKK)));
      }
    }

    var timeout;
    function scheduleRewrite(){
      clearTimeout(timeout);
      timeout = setTimeout(rewriteDrawer, 100);
    }

    var rootMO = new MutationObserver(function(muts){
      var touch = false;
      for (var i=0;i<muts.length;i++){
        var m = muts[i];
        if (Array.from(m.addedNodes || []).some(function(n){
          return n.nodeType===1 && (n.matches?.('.drawer') || n.querySelector?.('.drawer'));
        })){
          touch = true; break;
        }
        if (m.target && m.target.nodeType === 1 &&
            (m.target.matches?.('.drawer, .drawer *') || m.target.closest?.('.drawer'))){
          touch = true; break;
        }
        if (m.type === 'characterData' && m.target?.parentElement?.closest('.drawer')){
          touch = true; break;
        }
      }
      if (touch) scheduleRewrite();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){
        rootMO.observe(document.body, {childList:true, subtree:true, characterData:true});
        setTimeout(rewriteDrawer, 200);
      });
    } else {
      rootMO.observe(document.body, {childList:true, subtree:true, characterData:true});
      setTimeout(rewriteDrawer, 200);
    }
  })();

  // ---------- USF PRISER: DKK -> EUR (DOM-baseret, collections + search) ----------
  (function usfPriceDomPatch(){
    if (!isEN) return;

    function rewriteUSFPrices(root){
      (root || document).querySelectorAll(
        '.usf-results .usf-price, .usf-results .usf-discount, .usf-results .usf-price-wrapper'
      ).forEach(function(el){
        var txt = (el.textContent || '').trim();

        if (!txt || /€/.test(txt)) return;
        if (!/DKK|kr/i.test(txt)) return; // kun original DKK

      var val = parseDKK(txt);
      if (val == null) return;

      // sikkerhedsgitter: vi konverterer kun "rigtige" priser
      // (justér 100 til fx 500, hvis I ALDRIG har produkter under 500 DKK)
      if (val < 100) return;

      el.textContent = fmtEUR(toEUR(val));
      el.classList && el.classList.remove('money');

      });
    }

    rewriteUSFPrices(document);

    var mo = new MutationObserver(function(muts){
      var touch = false;
      for (var i=0;i<muts.length;i++){
        var m = muts[i];
        if (
          (m.target && m.target.closest && m.target.closest('.usf-results')) ||
          (m.addedNodes && m.addedNodes.length)
        ){
          touch = true; break;
        }
      }
      if (touch) rewriteUSFPrices(document);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){
        mo.observe(document.body, {childList:true, subtree:true, characterData:true});
      });
    } else {
      mo.observe(document.body, {childList:true, subtree:true, characterData:true});
    }
  })();

  // ---------- GLOBAL /en LINKS-FALLBACK ----------
  (function globalEnLinksFallback(){
    if (!isEN) return;
    function rewriteAll(root){
      var origin = location.origin.replace(/\/$/, '');
      (root||document).querySelectorAll(
        'a[href*="/products/"],a[href*="/collections/"],a[href="/cart"],a[href^="/cart"]'
      ).forEach(function(a){
        var href = a.getAttribute('href'); if (!href) return;
        var abs  = href.indexOf('http')===0 ? href : origin + (href[0]==='/'?'':'/') + href;
        try{
          var u = new URL(abs);
          if (!/^\/en(\/|$)/.test(u.pathname)) {
            u.pathname = '/en' + (u.pathname[0]==='/'?'':'/') + u.pathname;
            a.setAttribute('href', u.origin + u.pathname + u.search);
          }
        } catch(e){}
      });
    }
    rewriteAll(document);
    var mo = new MutationObserver(function(){ rewriteAll(document); });
    mo.observe(document.body, {childList:true, subtree:true});
  })();

  // ---------- USF FILTER LABELS / UI-TEKST + SORTERING PÅ EN ----------
  (function patchUsfFilterLabelsAndSort(){
    if (!isEN) return;

    var labelMap = {
      // facet-titler
      'Producent': 'Manufacturer',
      'Lokation': 'Location',
      // søgefelt
      'Søg': 'Search',
      // sort
      'Nyeste til ældste': 'Newest to oldest',
      'Ældste til nyeste': 'Oldest to newest',
      'Pris: Lav til høj': 'Price: Low to high',
      'Pris: Høj til lav': 'Price: High to low'
    };

    function translateFacetTitles(root){
      root.querySelectorAll('.usf-facet .usf-title .usf-label').forEach(function(btn){
        var txt = (btn.textContent || '').trim();
        if (labelMap[txt]) btn.textContent = labelMap[txt];
      });
    }

    function translateFacetSearch(root){
      root.querySelectorAll('.usf-facet .usf-search-box').forEach(function(input){
        var ph = input.getAttribute('placeholder') || '';
        if (labelMap[ph]) input.setAttribute('placeholder', labelMap[ph]);
      });
    }

    function translateSortDropdown(root){
      root.querySelectorAll('.usf-c-select__input-value, .usf-c-select__btn').forEach(function(btn){
        var txt = (btn.textContent || '').trim();
        if (labelMap[txt]) btn.textContent = labelMap[txt];
      });
    }

    // "Hent flere" → "Load more"
    function translateLoadMore(root){
      root.querySelectorAll('.usf-load-more, .usf-load-more span').forEach(function(btn){
        var txt = (btn.textContent || '').trim();
        if (txt === 'Hent flere') btn.textContent = 'Load more';
      });
    }

    // "Du har set X af Y produkter" → "You have viewed ..."
    function translateViewedSummary(root){
      root.querySelectorAll('.usf-sr-more .usf-title, .usf-sr-summary').forEach(function(el){
        var txt = (el.textContent || '').trim();
        if (!txt) return;
        var t = txt;
        t = t.replace('Du har set', 'You have viewed');
        t = t.replace('du har set', 'you have viewed');
        t = t.replace(' produkter', ' products');
        t = t.replace(' produkt',  ' product');
        if (t !== txt) el.textContent = t;
      });
    }

    // “Produkter” / “Produkt” alene (fx små badges)
    function translateWordProdukter(root){
      root.querySelectorAll('*').forEach(function(el){
        if (!el || !el.childNodes || el.childNodes.length !== 1) return;
        var txt = (el.textContent || '').trim();
        if (txt === 'Produkter') el.textContent = 'Products';
        if (txt === 'Produkt')  el.textContent = 'Product';
      });
    }

    function applyTranslations(root){
      root = root || document;
      translateFacetTitles(root);
      translateFacetSearch(root);
      translateSortDropdown(root);
      translateLoadMore(root);
      translateViewedSummary(root);
      translateWordProdukter(root);
    }

    applyTranslations(document);

    var mo = new MutationObserver(function(muts){
      var touch = false;
      for (var i=0;i<muts.length;i++){
        var m = muts[i];
        if (
          (m.target && m.target.closest && m.target.closest('.usf-facets, .usf-sr-container, .usf-c-select')) ||
          (m.addedNodes && m.addedNodes.length)
        ){
          touch = true; break;
        }
      }
      if (touch) applyTranslations(document);
    });

    if (document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', function(){
        mo.observe(document.body, {childList:true, subtree:true, characterData:true});
      });
    } else {
      mo.observe(document.body, {childList:true, subtree:true, characterData:true});
    }

  })();

})();
